import lottie from '../../module/animation/lottie';

class Animation {
    constructor() {
        this.items();
    }

    items() {
        if ($('#postmarks').length) {
            var lottie_postmarks = lottie.loadAnimation({
                container: document.getElementById('postmarks'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: '/json/postmarks/data.json?v=1',
            });

            ZoneObject.create('#postmarks', {
                run: () => {
                    lottie_postmarks.play();
                },
                stop: () => {
                    lottie_postmarks.stop();
                }
            });
        }
    }
}

new Animation();